// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CopyNotification_wrapper__2EPKl","button":"CopyNotification_button__1CVmb","alert":"CopyNotification_alert__1pkAh","fadeOut":"CopyNotification_fadeOut__3IDAG"};